// extracted by mini-css-extract-plugin
export default {"container":"Home_container__Z9cRi","heading":"Home_heading__Hr5LL","body":"Home_body__FpZi8","cards":"Home_cards__OhKLB","body2":"Home_body2__hNz8J","body3":"Home_body3__OB1xk"};